import React from 'react';
import { connect } from 'react-redux';
import { removeHtmlTags } from '../../utilities/methods';

import Accordion from '../Accordion/Accordion';
import ImageViewer from './ImageViewer';

import "./Room.css";

const SingleQuestion = ({ index, question, perguntaRealizada }) => {
    return (
        <Accordion className='mb-2'>
            <Accordion.Item eventKey={index}>
                <Accordion.Header bsPrefix='accordion-header'>
                    <div className='question_col_card_content question_col_card_start'>
                        <small className='question_col_card_paragraph'>{removeHtmlTags(perguntaRealizada)}</small>
                    </div>
                </Accordion.Header>
                <Accordion.Body>
                    <ImageViewer
                        mediaFile={question.imagem}
                    />
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

const ActorQuestions = ({ sendQuestions }) => {
    return (
        <div className='col-md-12'>
            {
                sendQuestions.map((question, index) => {
                    return (
                        <SingleQuestion
                            key={`${question.perguntaRealizada}-${index}`}
                            index={index}
                            question={question}
                            perguntaRealizada={question.perguntaRealizada}
                        />
                    )
                })
            }
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(ActorQuestions);
